import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 38 37" xmlns="http://www.w3.org/2000/svg">
    <path d="m23.489.5h-5.793c-9.497 0-17.196 7.699-17.196 17.196 0 9.498 7.699 17.197 17.196 17.197h5.793m3.005-27.455 10.259 10.258-10.259 10.259m-11.459-10.259h20.53" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" transform="translate(1 1)" />
  </svg>
);
